import { hookstate, State } from "@hookstate/core";

type RecoverPasswordEmailState = string | null;

const recoverPasswordEmailState: State<RecoverPasswordEmailState> = hookstate<RecoverPasswordEmailState>(null);

export const setRecoverPasswordEmailState = (email: string) => recoverPasswordEmailState.set(email);

export const clearRecoverPasswordEmailState = () => recoverPasswordEmailState.set(null);

export default recoverPasswordEmailState;